import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const wordBreak = system({
    wordBreak: true,
});

export interface WordBreakProps<ThemeType extends Theme = RequiredTheme> {
    wordBreak?: ResponsiveValue<CSS.Property.WordBreak, ThemeType> | undefined;
}
